import { isMockEnabled } from '../mocks/isEnabled';

const DEV_DOMAIN = 'homebot.test';

const isWithin = (host, domain) => host === domain || host.endsWith(`.${domain}`);

const parseUrl = (value, base) => {
  try {
    return new URL(value, base);
  } catch {
    return null;
  }
};

// Mikasa builds the callback on the customer-admin host, a sibling of the API host
// (api.homebotapp.com -> customer-admin.homebotapp.com), so trust the API host's parent domain.
const trustedDomainFor = (mikasaUrl) => {
  const mikasa = parseUrl(mikasaUrl);
  if (!mikasa || !/^https?:$/.test(mikasa.protocol)) return null;

  const labels = mikasa.hostname.split('.');
  return labels.length > 2 ? labels.slice(1).join('.') : mikasa.hostname;
};

/**
 * Returns true when `url` is safe to assign to window.location: an absolute https URL
 * (http only on *.homebot.test) whose host sits under the Mikasa API's parent domain.
 * In mock mode the fake callback lives on this app's own origin, so that is allowed too.
 */
export const isSafeAuthCallbackUrl = (
  url,
  {
    mikasaUrl = process.env.REACT_APP_MIKASA_URL,
    mockEnabled = isMockEnabled(),
    currentOrigin = window.location.origin
  } = {}
) => {
  if (typeof url !== 'string' || !/^https?:\/\//i.test(url.trim())) return false;

  const target = parseUrl(url);
  if (!target || target.username || target.password) return false;

  if (mockEnabled && target.origin === currentOrigin) return true;

  const host = target.hostname;
  const httpsOrDev = target.protocol === 'https:' || (target.protocol === 'http:' && isWithin(host, DEV_DOMAIN));
  if (!httpsOrDev) return false;

  const trustedDomain = trustedDomainFor(mikasaUrl);
  return Boolean(trustedDomain) && isWithin(host, trustedDomain);
};
